export default "__VITE_ASSET__aDnhLAWz__"